import { render } from "./BoxOfficeReportDateRangeCell.vue?vue&type=template&id=3acd1e4c"
import script from "./BoxOfficeReportDateRangeCell.vue?vue&type=script&lang=js"
export * from "./BoxOfficeReportDateRangeCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QChip from 'quasar/src/components/chip/QChip.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QChip,QPopupProxy,QDate});
